import { RESET_DELETE_ADDRESS} from '../types'
export const resetdeleteaddress= () => {

    return (dispatch) => {
        dispatch({ type: RESET_DELETE_ADDRESS });
    }
}